module.exports = __webpack_public_path__ + "img/serifnew_box17.81243e06.jpg";